import { color } from 'src/styles/js/primitives'

const chartDefaultColors = [
  color.blue400,
  color.red500,
  color.mint500,
  color.orange400,
  color.candy500,
  color.lime400,
  color.lavender600,
  color.yellow500,
  color.blush500,
  color.crimson400,
  color.forest400,
  color.violet300,
  color.navy300,
  color.green700,
  color.purple400,
]

export default chartDefaultColors
